import Cross from "@/UI/icons/cross.svg"

export function ToastCloseButton({ closeToast }) {
    return <img className="closeBlack" onClick={closeToast} src={Cross} alt="close" />
}
